import React from 'react';

import message from '../../../images/message_box_icon.svg';

import { FOHImage } from '../../ingredients';

export const FOHMessageBoxIcon = (props: any) => (
  <FOHImage
    source={{ uri: message }}
    style={
      props && !!props.style
        ? { width: 20, height: 20, ...props.style }
        : { width: 20, height: 20 }
    }
  />
);
